<template>
    <v-container>
        <v-row class="contentRow">
            <v-col cols="auto">
                <h1 class="text-left darkColor--text">Sender View</h1>
            </v-col>
			<v-col cols="auto" v-if="$accessToOperation('TX','C')">
                <v-btn :to="{name: 'Add Transaction'}" color="primary">
                    New Transaction
                    <v-icon right small>fas fa-plus</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="12" class="flex-grow-0 pt-20">
                <p>
                    This is an overview of the transactions you have sent.
                </p>
            </v-col>
            <v-spacer />
            
			<v-col cols="12">
				<v-tabs background-color="transparent" light centered icons-and-text>
					<v-tab>
						Recent
						<v-icon>fas fa-history</v-icon>
					</v-tab>
					<v-tab>
						Unconfirmed
						<v-icon>fas fa-ellipsis-h</v-icon>
					</v-tab>
					<v-tab>
						Archive
						<v-icon>fa-archive</v-icon>
					</v-tab>
					<v-tab>
						Drafts
						<v-icon>fa-inbox</v-icon>
					</v-tab>
					<v-tab-item>
						<br />
						<v-card background-color="transparent" elevation="0" outlined>
							<v-card-title class="text-center justify-left py-6">
								<h3 class="darkColor--text">Recent Transactions</h3>
							</v-card-title>
							<v-data-table
									:loading="recentOptions.loading"
									theme--
									light
									:headers="headers"
									:items="recentOptions.data"
									:items-per-page="recentOptions.limit"
									:server-items-length="recentOptions.total"
									:options.sync="recentOptions.options"
									class="light table"
									:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
							>
								<template v-slot:item.id="{ item }">
									<router-link :to="{name: `Transaction Details`, params: {id: item.id}}">{{item.id}}</router-link>
								</template>
								<template v-slot:item.timestamp="{ item }">
									{{  item.timestamp | moment("DD.MM.YYYY  h:mm:ss") }}
								</template>
								<template v-slot:item.status="{ item }">
									<v-tooltip top>
										<template v-slot:activator="{ on, attrs }">
											<p class="mx-2 my-0" :style="{ color: item.status.color}" v-bind="attrs" v-on="on">
												<v-icon  small :style="{ color: item.status.color}">fas fa-{{ item.status.icon}}</v-icon>
												{{item.status.description_short}}
											</p>
										</template>
										<span>{{item.status.description_long}}</span>
									</v-tooltip>
								</template>
								<template v-slot:item.blockchainStatus="{ item }" >
									<a  v-if="item.block!=='Awaiting validification'" :href="'https://nodes.orixe.tech/blocks/' + item.block" target='_blank'>Block #{{item.block}}</a>
									<p class="my-0 text-left font-italic" v-if="item.block==='Awaiting validification'">{{item.block}}</p>
								</template>
							</v-data-table>

							<br />
						</v-card>
					</v-tab-item>
					<v-tab-item>
						<br />
						<v-card background-color="transparent" elevation="0" outlined>
							<v-card-title class="text-center justify-left py-6">
								<h3 class="darkColor--text">Unconfirmed Transactions</h3>
							</v-card-title>
							<v-data-table
									:loading="unconfirmedOptions.loading"
									theme--
									light
									:headers="headers"
									:items="unconfirmedOptions.data"
									:items-per-page="unconfirmedOptions.limit"
									:server-items-length="unconfirmedOptions.total"
									:options.sync="unconfirmedOptions.options"
									class="light table mx-4 assessed-table"
									:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
							>
								<template v-slot:item.id="{ item }">
									<router-link :to="{name: `Transaction Details`, params: {id: item.id}}">{{item.id}}</router-link>
								</template>
								<template v-slot:item.timestamp="{ item }">
									{{  item.timestamp | moment("DD.MM.YYYY  h:mm:ss") }}
								</template>
								<template v-slot:item.status="{ item }">
									<v-tooltip top>
										<template v-slot:activator="{ on, attrs }">
											<p class="mx-2 my-0" :style="{ color: item.status.color}" v-bind="attrs" v-on="on">
												<v-icon  small :style="{ color: item.status.color}">fas fa-{{ item.status.icon}}</v-icon>
												{{item.status.description_short}}
											</p>
										</template>
										<span>{{item.status.description_long}}</span>
									</v-tooltip>
								</template>
								<template v-slot:item.blockchainStatus="{ item }" >
									<a  v-if="item.block!=='Awaiting validification'" :href="'https://nodes.orixe.tech/blocks/' + item.block" target='_blank'>Block #{{item.block}}</a>
									<p class="my-0 text-left font-italic" v-if="item.block==='Awaiting validification'">{{item.block}}</p>
								</template>
							</v-data-table>
							<br />
						</v-card>
					</v-tab-item>
					<v-tab-item>
						<br />
						<v-card background-color="transparent" elevation="0" outlined>
							<v-card-title class="text-center justify-left py-6">
								<h3 style="color: #2E8B57">Confirmed Transactions</h3>
							</v-card-title>
							<v-data-table
									:loading="confirmedOptions.loading"
									theme--
									light
									:headers="headers"
									:items="confirmedOptions.data"
									:items-per-page="confirmedOptions.limit"
									:server-items-length="confirmedOptions.total"
									:options.sync="confirmedOptions.options"
									class="light table mx-4 assessed-table"
									:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
							>
								<template v-slot:item.id="{ item }">
									<router-link :to="{name: `Transaction Details`, params: {id: item.id}}">{{item.id}}</router-link>
								</template>
								<template v-slot:item.timestamp="{ item }">
									{{  item.timestamp | moment("DD.MM.YYYY  h:mm:ss") }}
								</template>
								<template v-slot:item.status="{ item }">
									<v-tooltip top>
										<template v-slot:activator="{ on, attrs }">
											<p class="mx-2 my-0" :style="{ color: item.status.color}" v-bind="attrs" v-on="on">
												<v-icon  small :style="{ color: item.status.color}">fas fa-{{ item.status.icon}}</v-icon>
												{{item.status.description_short}}
											</p>
										</template>
										<span>{{item.status.description_long}}</span>
									</v-tooltip>
								</template>
								<template v-slot:item.blockchainStatus="{ item }" >
									<a  v-if="item.block!=='Awaiting validification'" :href="'https://nodes.orixe.tech/blocks/' + item.block" target='_blank'>Block #{{item.block}}</a>
									<p class="my-0 text-left font-italic" v-if="item.block==='Awaiting validification'">{{item.block}}</p>
								</template>
							</v-data-table>
							<br />
						</v-card>
						<br />
						<v-card background-color="transparent" elevation="0" outlined>
							<v-card-title class="text-center justify-left py-6">
								<h3 style="color: #B22222">Invalid Transactions</h3>
							</v-card-title>
							<v-data-table
									:loading="invalidOptions.loading"
									theme--
									light
									:headers="headers"
									:items="invalidOptions.data"
									:items-per-page="invalidOptions.limit"
									:server-items-length="invalidOptions.total"
									:options.sync="invalidOptions.options"
									class="light table mx-4 assessed-table"
									:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
							>
								<template v-slot:item.id="{ item }">
									<router-link :to="{name: `Transaction Details`, params: {id: item.id}}">{{item.id}}</router-link>
								</template>
								<template v-slot:item.timestamp="{ item }">
									{{  item.timestamp | moment("DD.MM.YYYY  h:mm:ss") }}
								</template>
								<template v-slot:item.status="{ item }">
									<v-tooltip top>
										<template v-slot:activator="{ on, attrs }">
											<p class="mx-2 my-0" :style="{ color: item.status.color}" v-bind="attrs" v-on="on">
												<v-icon  small :style="{ color: item.status.color}">fas fa-{{ item.status.icon}}</v-icon>
												{{item.status.description_short}}
											</p>
										</template>
										<span>{{item.status.description_long}}</span>
									</v-tooltip>
								</template>
								<template v-slot:item.blockchainStatus="{ item }" >
									<a  v-if="item.block!=='Awaiting validification'" :href="'https://nodes.orixe.tech/blocks/' + item.block" target='_blank'>Block #{{item.block}}</a>
									<p class="my-0 text-left font-italic" v-if="item.block==='Awaiting validification'">{{item.block}}</p>
								</template>
							</v-data-table>
							<br />
						</v-card>
					</v-tab-item>
					<v-tab-item>
						<br />
						<v-card background-color="transparent" elevation="0" outlined>
							<v-card-title class="text-center justify-left py-6">
								<h3 class="darkColor--text">Drafts</h3>
							</v-card-title>
							<v-data-table
									:loading="draftOptions.loading"
									theme--
									light
									:headers="draftHeaders"
									:items="draftOptions.data"
									:items-per-page="draftOptions.limit"
									:server-items-length="draftOptions.total"
									:options.sync="draftOptions.options"
									class="light table"
									:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
							>
								<template v-slot:item.ID="{ item }">
									<router-link :to="'/trace/drafts/'+item.ID">{{item.ID}}</router-link>
								</template>
								<template v-slot:item.Timestamp="{ item }">
									{{  item.Timestamp | moment("DD.MM.YYYY  h:mm:ss") }}
								</template>
								<template v-slot:item.delete="{ item }">
									<v-btn color="red" v-on:click="showDeleteDialog(item)">
										<v-icon color="white" small>fas fa-times</v-icon>
									</v-btn>
								</template>
							</v-data-table>
							<br />
						</v-card>
					</v-tab-item>
				</v-tabs>
			</v-col>
        </v-row>
<!--        Delete Draft Modal-->
        <v-dialog v-model="deleteDialog" max-width="500px">
            <v-card>
                <v-card-title>Are you sure you want to delete this draft?</v-card-title>
                <v-card-actions>
                    <v-btn color="primary" text @click="deleteDialog = false">Close</v-btn>
                    <v-btn color="error" text @click="deleteDraft">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import TransactionAPI from "../../api/trace/transaction"
import DraftsAPI from "../../api/trace/draft"
import LoadingState from "../../consts/LoadingState"
import TransactionStatus from "../../consts/TransactionStatus"
export default {
	name: "SendTransactionView",

	data() {
		return {
			recentOptions:{
				limit:5,
				offset:0,
				total:0,
				data:[],
				loading:true,
				options: {},
			},
			unconfirmedOptions:{
				limit:5,
				offset:0,
				total:0,
				data:[],
				filter:[TransactionStatus.PENDING,TransactionStatus.REQUESTED_EDIT],
				loading:true,
				options: {},
			},
			confirmedOptions:{
				limit:5,
				offset:0,
				total:0,
				data:[],
				filter:[TransactionStatus.CONFIRMED],
				loading:true,
				options: {},
			},
			invalidOptions:{
				limit:5,
				offset:0,
				total:0,
				data:[],
				filter:[
					TransactionStatus.REJECTED,TransactionStatus.INVALID,TransactionStatus.CANCELLED,TransactionStatus.RESCINDED,
					TransactionStatus.EDITED,TransactionStatus.INHERITED_ERROR
				],
				loading:true,
				options: {},
			},
			draftOptions:{
				limit:5,
				offset:0,
				total:0,
				data:[],
				loading:true,
				options: {},
			},
			headers: [
				{
					text: "Transaction ID",
					align: "start",
					sortable: false,
					value: "id",
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Sender Order Number",
					value: "senderordernumber",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Recipient",
					value: "recipient",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Status",
					value: "status",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Blockchain Status",
					value: "blockchainStatus",
					sortable: false,
					class: "darkColor--text"
				}
			],
			draftHeaders:[
				{
					text: "Draft ID",
					align: "start",
					sortable: false,
					value: "ID",
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "Timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Delete",
					value: "delete",
					sortable: false,
					class: "darkColor--text"
				}
			],
			deleteDialog:false,
			selectedDraftID:null,
		}
	},
	mounted() {
		this.getRecentTransaction()
		this.getUnconfirmedTransaction()
		this.getConfirmedTransaction()
		this.getInvalidTransaction()
		this.getDrafts()
	},
	watch: {
		"recentOptions.options": {
			handler () {
				//if user select all
				if (this.recentOptions.options.itemsPerPage===-1){
					this.recentOptions.options.itemsPerPage=this.recentOptions.total
				}
				this.recentOptions.offset=(this.recentOptions.options?.page-1) * this.recentOptions.options?.itemsPerPage
				this.recentOptions.limit=this.recentOptions.options?.itemsPerPage
				this.getRecentTransaction()
			},
			deep: true,
		},
		"unconfirmedOptions.options": {
			handler () {
				//if user select all
				if (this.unconfirmedOptions.options.itemsPerPage===-1){
					this.unconfirmedOptions.options.itemsPerPage=this.unconfirmedOptions.total
				}
				this.unconfirmedOptions.offset=(this.unconfirmedOptions.options?.page-1) * this.unconfirmedOptions.options?.itemsPerPage
				this.unconfirmedOptions.limit=this.unconfirmedOptions.options?.itemsPerPage
				this.getUnconfirmedTransaction()
			},
			deep: true,
		},
		"confirmedOptions.options": {
			handler () {
				if (this.confirmedOptions.options.itemsPerPage===-1){
					this.confirmedOptions.options.itemsPerPage=this.confirmedOptions.total
				}
				this.confirmedOptions.offset=(this.confirmedOptions.options?.page-1) * this.confirmedOptions.options?.itemsPerPage
				this.confirmedOptions.limit=this.confirmedOptions.options?.itemsPerPage
				this.getConfirmedTransaction()
			},
			deep: true,
		},
		"invalidOptions.options": {
			handler () {
				if (this.invalidOptions.options.itemsPerPage===-1){
					this.invalidOptions.options.itemsPerPage=this.invalidOptions.total
				}
				this.invalidOptions.offset=(this.invalidOptions.options?.page-1) * this.invalidOptions.options?.itemsPerPage
				this.invalidOptions.limit=this.invalidOptions.options?.itemsPerPage
				this.getInvalidTransaction()
			},
			deep: true,
		},
		"draftOptions.options": {
			handler () {
				if (this.draftOptions.options.itemsPerPage===-1){
					this.draftOptions.options.itemsPerPage=this.draftOptions.total
				}
				this.draftOptions.offset=(this.draftOptions.options?.page-1) * this.draftOptions.options?.itemsPerPage
				this.draftOptions.limit=this.draftOptions.options?.itemsPerPage
				this.getDrafts()
			},
			deep: true,
		},
	},
	methods: {
		getRecentTransaction(){
			this.recentOptions.loading=true
			TransactionAPI.getTransactionList(this.recentOptions.limit,this.recentOptions.offset, 1)
				.then(data => {
					this.recentOptions.total=data?.metadata?.pagination?.totalRecords
					this.recentOptions.data=data?.data
					this.recentOptions.loading=false
				})
				.catch(error => {
					this.recentOptions.loading=false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		getUnconfirmedTransaction(){
			this.unconfirmedOptions.loading=true
			TransactionAPI.getFilteredTransactionList(this.unconfirmedOptions.limit,this.unconfirmedOptions.offset, this.unconfirmedOptions.filter,1)
				.then(data => {
					this.unconfirmedOptions.total=data?.metadata?.pagination?.totalRecords
					this.unconfirmedOptions.data=data?.data
					this.unconfirmedOptions.loading=false
				})
				.catch(error => {
					this.recentOptions.loading=false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		getConfirmedTransaction(){
			this.confirmedOptions.loading=true
			TransactionAPI.getFilteredTransactionList(this.confirmedOptions.limit,this.confirmedOptions.offset, this.confirmedOptions.filter,1)
				.then(data => {
					this.confirmedOptions.total=data?.metadata?.pagination?.totalRecords
					this.confirmedOptions.data=data?.data
					this.confirmedOptions.loading=false
				})
				.catch(error => {
					this.recentOptions.loading=false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		getInvalidTransaction(){
			this.invalidOptions.loading=true
			TransactionAPI.getFilteredTransactionList(this.invalidOptions.limit,this.invalidOptions.offset, this.invalidOptions.filter,1)
				.then(data => {
					this.invalidOptions.total=data?.metadata?.pagination?.totalRecords
					this.invalidOptions.data=data?.data
					this.invalidOptions.loading=false
				})
				.catch(error => {
					this.recentOptions.loading=false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		getDrafts(){
			this.draftOptions.loading=true
			DraftsAPI.getDraftList(this.draftOptions.limit,this.draftOptions.offset)
				.then(data => {
					this.draftOptions.total=data?.metadata?.pagination?.totalRecords
					this.draftOptions.data=data?.data
					this.draftOptions.loading=false
				})
				.catch(error => {
					this.recentOptions.loading=false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		deleteDraft(){
			this.deleteDialog = false
			DraftsAPI.deleteDraft(this.selectedDraftID)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Draft was successfully removed.",
						{ root: true }
					)
					this.getDrafts()
				})
				.catch(error => {
					this.recentOptions.loading=false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		showDeleteDialog(item){
			this.selectedDraftID = item.ID
			this.deleteDialog = !this.deleteDialog
		}
	}
}
</script>
